// Models
import { createAuthStoreDefaultModel } from './auth/auth.store'

const authModels = {
  auth: createAuthStoreDefaultModel(),
}

export { authModels }
